import React from 'react';

import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';

import { ICondoUnitWeek } from '@common-types';

import { CondoWeeksDatesTable } from '../condo-week-dates-table';

import './style.scss';

interface IProps extends RouteComponentProps {
  condo: ICondoUnitWeek;

  redirect: string;
}

function CondoWeeksCardWrapper(props: IProps) {

  const { condo, redirect } = props;
  const { image } = condo;
  
  return (
    <div className="condo-weeks-card-wrapper">
      <div className="tns-item">
        <div className="card" style={{ backgroundImage: `url(${image})` }}>
          <div className="position-absolute top-100 start-50 translate-middle w-100" style={{ zIndex: 200 }}>
            <div className="card-body text-center bg-mode shadow rounded mx-4 p-3" style={{ display: 'flex', flexDirection: 'column' }}>
              <CondoWeeksDatesTable condo={condo} displayReduced />

              {redirect ? (
                <div className="mt-2">
                  <a className="btn btn-sm btn-success mb-0" style={{ cursor: 'pointer' }} href="https://getaways-club.com" target="_blank">Book</a>
                </div>) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const CondoWeeksCardWrapperRouter = withRouter(CondoWeeksCardWrapper);

export const CondoWeeksCard = connect()(CondoWeeksCardWrapperRouter);
